import { render, staticRenderFns } from "./addClinicGallery.vue?vue&type=template&id=13587566"
import script from "./addClinicGallery.vue?vue&type=script&lang=js"
export * from "./addClinicGallery.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports